/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<6d613d3791acaf6e34897c6c72b2168b>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType13 = {
  getVariation: function getVariation(n) {
    if (n === 1 || n === 2 || n === 3 || n % 10 !== 4 && n % 10 !== 6 && n % 10 !== 9) {
      return IntlVariations.NUMBER_ONE;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType13;